import { FundsCommandsService_fundCommandsServiceGetEntities } from '@festina/unitlink-general-types/unitlink/hooks/FundsCommandsService_fundCommandsServiceGetEntities'

export const useFetchFundCommands =
  FundsCommandsService_fundCommandsServiceGetEntities.useSuspenseQuery
